import type { IconGlyph } from '@sunwebgroup/ui-components'
import type { IconGlyph as UDSIconGlyph } from '@sunwebgroup/ui-components/uds'
import type { CatalogueType } from '@/config/types'
import type { SiteName } from '@/scopes/common/domain/types'

export function getCatalogues(siteName: SiteName): CatalogueType[] {
  if (siteName === 'sunwebuk' || siteName === 'sunwebde') {
    return ['winter']
  }

  if (siteName === 'elizanl' || siteName === 'elizabe') {
    return ['summer']
  }

  if (siteName === 'sunwebfr') {
    return ['winter', 'summer']
  }

  return ['summer', 'winter']
}

export function getExtraCatalogueIcon(siteName: SiteName): IconGlyph | null {
  if (siteName === 'sunwebse' || siteName === 'sunwebdk') {
    return 'IconAirplaneRight'
  }
  return null
}

export function getExtraCatalogueIconUDS(siteName: SiteName): UDSIconGlyph | null {
  if (siteName === 'sunwebse' || siteName === 'sunwebdk') {
    return 'AirplaneToRight'
  }
  return null
}
